import React from "react";
import { useParams } from "react-router";
import { useContacts, initialParams } from "@/_actions/contactActions";
import ContactDetail from "./ContactDetail";

export default function ContactInfo() {
  const { contactId } = useParams();
  const hasValidId = /^[1-9]\d*$/.test(contactId ?? "");
  const { data, isLoading, error } = useContacts(
    { page: 1, status: initialParams.status, id: contactId },
    { enabled: hasValidId },
  );
  const contact = data?.results?.find((item) => String(item.id) === contactId);

  return (
    <>
      <h1 className="title">Contacto</h1>
      {error ? (
        <p role="alert" className="mt-7 text-sm text-red-600">
          No se pudo cargar el contacto. Intenta recargar la página.
        </p>
      ) : isLoading ? (
        <p role="status" className="mt-7 text-sm text-muted-foreground">
          Cargando contacto…
        </p>
      ) : contact ? (
        <div className="col-span-4 mt-7 md:flex">
          <ContactDetail contact={contact} />
        </div>
      ) : (
        <p role="status" className="mt-7 text-sm text-muted-foreground">
          No se encontró el contacto o no tienes acceso a él.
        </p>
      )}
    </>
  );
}
